<template>
  <div>
    <a
      class="ml-2 mr-2 cursor-pointer"
      data-toggle="modal"
      data-target="#assignedResourceModal"
      @click="$parent.$parent.$parent.assignedResourcesFunction(data)"
      :class="options.class"
    >
      <p v-if="data.role === Roles.SiteAdmin && data.siteCount > 0">
        {{ data.siteCount }} {{ data.siteCount == 1 ? "Site" : "Sites" }}
      </p>
      <p v-if="data.role === Roles.GroupAdmin && data.groupCount > 0">
        {{ data.groupCount }}
        {{ data.groupCount == 1 ? "Group" : "Groups" }}
      </p>  
      <p v-if="data.role === Roles.CompanyAdmin && data.companyCount > 0">
        {{ data.companyCount }}
        {{ data.companyCount == 1 ? "Company" : "Companies" }}
      </p>
      <p v-if="data.role === Roles.PartnerAdmin && data.partnerId">
        1 Partner
      </p>
    </a>
  </div>
</template>

<script>
import { Roles } from "@/helpers/enums/Roles";
export default {
  name: "userAsset",
  components: {},
  props: {
    data: {
      type: Array,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      Roles: Roles,
    };
  },
};
</script>
